export interface MapMarker {
  lat: number;
  lng: number;
}

export interface GoogleMapInstance {
  setCenter(center: MapMarker): void;
  setZoom(zoom: number): void;
  fitBounds(bounds: unknown, padding?: number): void;
}

export interface GoogleMapsApi {
  LatLngBounds: new () => {
    extend(marker: MapMarker): void;
  };
}

export interface GoogleMapsReadyPayload {
  map: Ref<GoogleMapInstance>;
  mapsApi: Ref<GoogleMapsApi>;
}

export function useGoogleMap() {
  const fitMarkers = ({
    map,
    mapsApi,
    markers,
    singleMarkerZoom,
    padding,
  }: {
    map: GoogleMapInstance;
    mapsApi: GoogleMapsApi;
    markers: MapMarker[];
    singleMarkerZoom?: number;
    padding?: number;
  }) => {
    if (!markers.length) {
      return;
    }
    const cleanSingleMarkerZoom = singleMarkerZoom ?? 15;
    const cleanPadding = padding ?? 50;

    if (markers.length === 1) {
      const firstMarker = markers[0];
      if (!firstMarker) {
        return;
      }

      map.setCenter(firstMarker);
      map.setZoom(cleanSingleMarkerZoom);
      return;
    }

    const bounds = new mapsApi.LatLngBounds();

    markers.forEach((marker) => {
      bounds.extend(marker);
    });

    map.fitBounds(bounds, cleanPadding);
  };

  return {
    fitMarkers,
  };
}
